export enum TileType {
  OperationsTile = 'operationsTile',
  ServicesTile = 'servicesTile',
  ShiftsTile = 'shiftsTile',
  CalendarTile = 'calendarTile',
  ShareTile = 'shareTile',
  StaffTile = 'staffTile',
  PayrollTile = 'payrollTile',
  InvoicingTile = 'invoicingTile',
  QualificationTile = 'qualificationTile',
  EquipmentTile = 'equipmentTile',
}

export interface SideNavSetting {
  isCollapsed: boolean;
  sideNavExpandedTile?: TileType;
}

export interface SideNavSettingModel {
  sideNavSettings: {
    [userId in string]: SideNavSetting;
  };
}
